import React from 'react';
import { useLocation } from 'react-router-dom';
import CardForm from '../components/CardForm';
import Loader from '../components/Loader';
import { getBrowserId } from '../utils/getBrowserId';
import { fetchAuth } from '../utils/fetchAuth';

const apiUrl = process.env.REACT_APP_API_URL || '';

interface Props {
    loading?: boolean;
}

const Login: React.FC<Props> = ({ loading }) => {
    // dentro do seu componente
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const continueTo = searchParams.get('continue');

    if (loading) return <Loader />;

    return (
        <CardForm
            title="Login"
            action={`${apiUrl}/login/authenticate`}
            method="POST"
            fields={[
                { name: 'email', type: 'email', label: 'Email', required: true },
                { name: 'password', type: 'password', label: 'Senha', required: true },
                { name: 'browser_id', type: 'hidden', label: 'Browser ID' },
            ]}
            defaultValues={{
                browser_id: getBrowserId(),
            }}
            link={{ label: 'Esqueci minha senha', url: '/login/esqueci-senha' + (continueTo ? `?continue=${encodeURIComponent(continueTo)}` : '') }}
            submitLabel="Entrar"
            onSubmit={async (formData, action, method) => {
                // <- comportamento padrão (form encoded + fetch)
                const body = new URLSearchParams();
                for (const key in formData) {
                    const value = formData[key];
                    if (Array.isArray(value)) {
                        value.forEach(v => body.append(key, v));
                    } else {
                        body.append(key, value);
                    }
                }

                const response = await fetchAuth(action, {
                    method,
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: method === 'POST' ? body.toString() : undefined,
                    credentials: 'include',
                });

                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(errorData.message || 'Erro ao fazer login');
                }

                const responseData = await response.json();

                if (responseData.access_token) {
                    localStorage.setItem('access_token', responseData.access_token);
                } else {
                    throw new Error('Token de acesso não recebido');
                }

                window.location.href = continueTo || '/';

                return {
                    message: 'Aguarde enquanto você é redirecionado...',
                    errorCode: 0,
                    //redirect: continueTo || undefined,
                }
            }}
        />
    );
}

export default Login;
